!(function (BuildASet, $, undefined) {
  BuildASet.selectedVariants = {};

  function updateBtn(btnEl, disabledStatus, copy) {
    btnEl.html(copy);
    btnEl.prop("disabled", disabledStatus);
  }

  var bindUIActions = function () {
    $(".styled_select").selectpicker();

    $(".styled_select").on(
      "changed.bs.select",
      function (e, clickedIndex, isSelected, previousValue) {
        $(this).selectpicker("toggle");
      }
    );

    var bas_cards = $(".bas_cards").flickity({
      cellSelector: ".build_a_set_block",
      fade: true,
      pageDots: false,
      prevNextButtons: false,
      adaptiveHeight: true,
      draggable: false,
      imagesLoaded: true,
      wrapAround: true,
    });

    bas_cards.on("change.flickity", function (event, index) {
      var widthPercentageBase = 100 / $(".build_a_set_block").length;
      var widthPercentage = widthPercentageBase * (index + 1);
      $(".bas_progress_bar").css("width", widthPercentage + "%");
      var setItems = "";
      for (const key in BuildASet.selectedVariants) {
        if (BuildASet.selectedVariants[key] != null) {
          const productTitleParts =
            BuildASet.selectedVariants[key].name.split("-");
          productTitleParts.shift();
          productTitle = productTitleParts.join("/").trim();
          setItems +=
            '<p class="">1 ' +
            window.buildASetDetails[key] +
            ": " +
            productTitle +
            " - " +
            Shopify.formatMoney(
              BuildASet.selectedVariants[key].price,
              Shopify.money_format
            ) +
            "</p>";
        }
      }
      $(".bulld_a_set_items").html(setItems);
    });

    $(".bas_atc").click(function (e) {
      e.preventDefault();
      var cartItems = [];
      for (const key in BuildASet.selectedVariants) {
        if (BuildASet.selectedVariants[key] != null) {
          var cartItem = {
            id: BuildASet.selectedVariants[key].id,
            quantity: 1,
          };
          cartItems.push(cartItem);
        }
      }
      CartJS.addItems(cartItems, {
        success: function () {
          $("#offcanvas_cart").toggleClass("show");
          $("body").toggleClass("offcanvas-active");
          $(".screen-overlay").toggleClass("show");
        },
        error: function () {
          alert(
            "Oops! There was a problem adding this item to your cart. It may no longer be available."
          );
        },
      });
    });

    $(".bas_back").click(function (e) {
      e.preventDefault();
      bas_cards.flickity("previous", true);
    });
    $(".bas_next").click(function (e) {
      e.preventDefault();
      bas_cards.flickity("next", true);
    });

    $(".skip_step").click(function (e) {
      e.preventDefault();
      var currentStep = $(this).attr("data-step");
      BuildASet.selectedVariants[currentStep] = null;
      bas_cards.flickity("next", true);
    });

    $("[bas-variant-select]").change(function (e) {
      e.preventDefault();

      var parentEl = $(this).closest(".build_a_set_block");
      var currentStep = parentEl.data("step");
      var productId = $(
        ".grouped_variant_option_1 option:selected",
        parentEl
      ).data("product-id");

      $(".bas_featured_image", parentEl).attr(
        "src",
        Shopify.Image.getSizedImageUrl(
          window.productCard[productId].featured_image,
          "1200x1200"
        )
      );
      var selectedVariant = window.productCard[productId].variants.find(
        (variant) =>
          variant.option1 ==
          $(".grouped_variant_option_2 option:selected", parentEl).val()
      );
      var selectedVariantFull = window.productCardFull[productId].variants.find(
        (variant) =>
          variant.option1 ==
          $(".grouped_variant_option_2 option:selected", parentEl).val()
      );
      var atcBtn = parentEl.find(".bas_next");
      if (selectedVariant) {
        if (selectedVariant.available) {
          BuildASet.selectedVariants[currentStep] = selectedVariant;
          if (selectedVariantFull.preorderDate) {
            updateBtn(
              atcBtn,
              null,
              "Next - Ships " + selectedVariantFull.preorderDate
            );
          } else {
            updateBtn(atcBtn, null, "Next");
          }
        } else {
          updateBtn(atcBtn, "disabled", "Sold Out");
        }
      } else {
        updateBtn(atcBtn, "disabled", "Not Available");
      }
    });
  };

  BuildASet.init = function () {
    bindUIActions();
  };
})((window.BuildASet = window.BuildASet || {}), jQuery),
  (function (QuickShop, $, undefined) {
    function variantSearch(conditions) {
      return Object.keys(this).every((key) => conditions[key] === this[key]);
    }

    var bindUIActions = function () {
      $(document).on(
        {
          mouseenter: function () {
            //stuff to do on mouse enter
            const imgEl = $(this).find(".card-img-top");
            imgEl.attr("data-img-main", imgEl.attr("src"));
            imgEl.attr("src", $(this).find(".card-img-top").data("img-alt"));
          },
          mouseleave: function () {
            const imgEl = $(this).find(".card-img-top");
            var imageToUse = imgEl.attr("data-img-main");
            imgEl.attr("src", imageToUse);
          },
        },
        ".card.product_card"
      ); //pass the element as an argument to .on

      $("[data-trigger]").on("click", function () {
        var trigger_id = $(this).attr("data-trigger");
        $(trigger_id).toggleClass("show");
        if (!$(this).hasClass("context_badge")) {
          $("body").toggleClass("offcanvas-active");
        }
      });

      // close button
      $(".btn-close").click(function () {
        $(".navbar-collapse").removeClass("show");
        $("body").removeClass("offcanvas-active");
      });
    };

    QuickShop.init = function () {
      bindUIActions();
    };
  })((window.QuickShop = window.QuickShop || {}), jQuery);

// ST | KT - 230626 - close other menus when one is opened
$(".first_level_link__dropdown").click(function (e) {
  e.preventDefault();

  const allSubMenus = $(".nested_nav_list");
  const subMenu = $(this).next(".nested_nav_list");
  const allArrows = $(".offcanvas_nav_content #svg-mobile_dropdown_arrow");
  if (!$(this).hasClass("active")) {
    $(".first_level_link__dropdown").removeClass("active");
    allArrows.text("Down Arrow");
    allSubMenus.removeClass("active");
  }
});

/*!
 * Flickity sync v2.0.0
 * enable sync for Flickity
 */

/*jshint browser: true, undef: true, unused: true, strict: true*/

(function (window, factory) {
  // universal module definition
  /*jshint strict: false */ /*globals define, module, require */
  if (typeof define == "function" && define.amd) {
    // AMD
    define(["flickity/js/index", "fizzy-ui-utils/utils"], factory);
  } else if (typeof module == "object" && module.exports) {
    // CommonJS
    module.exports = factory(require("flickity"), require("fizzy-ui-utils"));
  } else {
    // browser global
    window.Flickity = factory(window.Flickity, window.fizzyUIUtils);
  }
})(window, function factory(Flickity, utils) {
  "use strict";

  // -------------------------- sync prototype -------------------------- //

  // Flickity.defaults.sync = false;

  Flickity.createMethods.push("_createSync");

  Flickity.prototype._createSync = function () {
    this.syncers = {};
    var syncOption = this.options.sync;

    this.on("destroy", this.unsyncAll);

    if (!syncOption) {
      return;
    }
    // HACK do async, give time for other flickity to be initalized
    var _this = this;
    setTimeout(function initSyncCompanion() {
      _this.sync(syncOption);
    });
  };

  /**
   * sync
   * @param {Element} or {String} elem
   */
  Flickity.prototype.sync = function (elem) {
    elem = utils.getQueryElement(elem);
    var companion = Flickity.data(elem);
    if (!companion) {
      return;
    }
    // two hearts, that beat as one
    this._syncCompanion(companion);
    companion._syncCompanion(this);
  };

  /**
   * @param {Flickity} companion
   */
  Flickity.prototype._syncCompanion = function (companion) {
    var _this = this;
    function syncListener() {
      var index = _this.selectedIndex;
      // do not select if already selected, prevent infinite loop
      if (companion.selectedIndex != index) {
        companion.select(index);
      }
    }
    this.on("select", syncListener);
    // keep track of all synced flickities
    // hold on to listener to unsync
    this.syncers[companion.guid] = {
      flickity: companion,
      listener: syncListener,
    };
  };

  /**
   * unsync
   * @param {Element} or {String} elem
   */
  Flickity.prototype.unsync = function (elem) {
    elem = utils.getQueryElement(elem);
    var companion = Flickity.data(elem);
    this._unsync(companion);
  };

  /**
   * @param {Flickity} companion
   */
  Flickity.prototype._unsync = function (companion) {
    if (!companion) {
      return;
    }
    // I love you but I've chosen darkness
    this._unsyncCompanion(companion);
    companion._unsyncCompanion(this);
  };

  /**
   * @param {Flickity} companion
   */
  Flickity.prototype._unsyncCompanion = function (companion) {
    var id = companion.guid;
    var syncer = this.syncers[id];
    this.off("select", syncer.listener);
    delete this.syncers[id];
  };

  Flickity.prototype.unsyncAll = function () {
    for (var id in this.syncers) {
      var syncer = this.syncers[id];
      this._unsync(syncer.flickity);
    }
  };

  // -----  ----- //

  return Flickity;
});

$(".desktop_search_link").click(function (e) {
  e.preventDefault();
  setTimeout(function () {
    $(".search_box input.boost-pfs-search-box").focus();
  }, 300);
});

//for product accordion slider

var pdp_carousel = $(".pdp_image_gallery_slider").flickity({
  fade: true,
  cellSelector: ".pdp_image_gallery_item",
  pageDots: true,
  prevNextButtons: true,
  adaptiveHeight: true,
  draggable: true,
  imagesLoaded: true,
  wrapAround: true,
  adaptiveWidth: true,
  contain: true,
});

//I started accordion items with a class .show to open them for flickity and then close them in 1 second as soon as flickity initializes height.
$(document).ready(function () {
  var elements = $(".show-for-flickity:not(.open-on-load)");
  setTimeout(function () {
    elements.removeClass("show");
  }, 1000);
});

/**
 * Flickity accessibility patch. Adds aria-hidden to slides which are outside the horizontal viewport.
 *
 * Adapted from https://gist.github.com/neodigm/bf64202df7ff854c910977eb1f2515a0
 */
class FlickPatch {
  //  Flick Carousel ARIA-HIDDEN observer
  constructor(document, selector) {
    this.document = document;
    this.selector = selector;
    this.sliders = [];
  }
  init() {
    this.sliders = Array.from(this.document.querySelectorAll(this.selector));
    if (this.sliders.length) {
      this.sliders.forEach((slider) => {
        slider.addEventListener("focusin", (_event) => {
          this.removeAttr(slider);
        });

        const mutationObserver = new MutationObserver(() => {
          if (flickPatch && typeof flickPatch.removeAttr === "function") {
            flickPatch.removeAttr(slider);
          }
        });
        mutationObserver.observe(slider, {
          attributes: true,
          childList: true,
          subtree: true,
        });
        this.removeAttr(slider);
      });
    }
    return this;
  }

  removeAttr(slider) {
    const threshold = 0.1;
    if (slider) {
      const classes = [".carousel_product_card", ".testimonial_carousel_cell"];
      const slides = [...slider.querySelectorAll(classes.join(", "))];
      if (slides.length > 0) {
        slides.forEach((slide) => {
          var rect = slide.getBoundingClientRect();
          const overlap = rect.width * threshold;
          var viewWidth = Math.max(
            document.documentElement.clientWidth,
            window.innerWidth
          );
          if (!(rect.right < 0 + overlap || rect.left >= viewWidth - overlap)) {
            if (slide.getAttribute("aria-hidden")) {
              slide.removeAttribute("aria-hidden");
            }
            // if (slide.getAttribute("tabindex") === "-1") {
            //   slide.removeAttribute("tabindex");
            // }
          } else {
            if (!slide.getAttribute("aria-hidden")) {
              slide.setAttribute("aria-hidden", "true");
            }
            // if (slide.getAttribute("tabindex") !== "-1") {
            //   slide.setAttribute("tabindex", "-1");
            // }
          }
        });
      }
    }
  }
}

let flickPatch = {};

document.addEventListener("DOMContentLoaded", () => {
  flickPatch = new FlickPatch(document, ".flickity-slider");
  flickPatch.init();
});

window.addEventListener("load", () => {
  if (flickPatch) {
    flickPatch.init();
  }
});

if (window.location.pathname.startsWith('/apps/giftregistry')) {
  document.querySelectorAll('.giftreggie-signup label[for]').forEach(label => {
    label.setAttribute('for', label.getAttribute('for').replace(/_/g, '-'));
  });
}